const angular = require('angular');
const app = angular.module('learn-directives');
const moment = require('moment-timezone');
/**
 * Defines the media viewer component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Analyze} Analyze injected to gain access to the global Analyze functions and properties
 * @argument {Files} Files the resource defined to manage Files
 * @argument {Assignments} Assignments the resource defined to manage Assignments
 */
app.directive('multiSessionWorkshopViewer', [
  'Application', 'Authorization',
  'MultiSessionWorkshops',
  'Workshops',
  'WorkshopInstances',
  'Ratings',
  'Analyze',
  'ContentAuth',
  'SurveyHelper',
  '$q',
  '$translate',
  function (Application, Authorization, MultiSessionWorkshops, Workshops, WorkshopInstances, Ratings, Analyze, ContentAuth, SurveyHelper, $q, $translate) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        previewData: '=?',
        specialClose: '&',
        preview: '=',
        contentId: '=?',
        journeyId: '=?'
      },
      template: require('../../templates/directives/multi-session-workshop-viewer.html'),
      controller: [
        '$scope',
        '$window',
        function ($scope, $window) {
          var self = this;
          var routeParameters = Application.navigation.getRouteParameters();
          self.contentId = $scope.contentId || routeParameters.id;
          self.inJourney = !!$scope.journeyId;
          self.company = Authorization.getAuthToken().company;
          self.currentUserId = Authorization.getAuthToken().user._id;
          self.inEditing = new RegExp('edit').test(self.currentUrl);
          var guessedTz = moment.tz.guess();

          if (!self.company.feature_flags.enable_multisession_workshops) {
            Application.navigation.goTo('/explore');
            return;
          }

          self.actions = {
            register: function () {
              if (self.cohortConfig.isCohort && self.cohortConfig.currentCohort) {
                self.actions.registerCohort();
              } else if (self.workshop.type === 'freeform') {
                self.actions.registerFreeform();
              } else {
                Application.messaging.addMessage({ type: 'error', duration: 6, text: 'Unable to register for this Multi Session Workshop. Cohort/Freeform type mismatch' });
              }
            },
            registerFreeform: function () {
              self.config.loading = true;

              if (!self.actions.validateRegistration()) {
                return;
              }

              const instanceIds = Object.values(self.sessionsConfig.selectedInstanceIdsBySessionId).concat(Object.values(self.sessionsConfig.attendedSessions));
              if (instanceIds.length !== self.sessionsConfig.allSessionIds.length) {
                Application.messaging.addMessage({ type: 'error', duration: 6, text: 'A date must be selected for each Session in order to register.' });
                return;
              }

              self.config.setAllRegisteredInstances(instanceIds);

              MultiSessionWorkshops.register({ subresource: self.workshop.id }, { instanceIds: instanceIds, userId: self.currentUserId })
                .$promise.then(function (res) {
                  $translate('multiSessionWorkshopViewer.successfullyRegisteredMessage', { name: self.workshop.name }).then(function (data) {
                    Application.messaging.addMessage({
                      type: 'success',
                      duration: 5,
                      text: data,
                    });
                  });
                  self.config.isRegistered = true;
                  if (!self.config.attendedSome) {
                    self.sessionsConfig.allAvailableSeats -= 1;
                  }
                  self.config.setButtons();
                  self.config.loading = false;
                })
                .catch(function (err) {
                  console.error('Error registering for Multi Session Workshop: ', err);
                  self.config.loading = false;
                });
            },
            registerCohort: function () {
              self.config.loading = true;

              if (!self.actions.validateRegistration()) {
                return;
              }

              MultiSessionWorkshops.register({ subresource: self.workshop.id }, { cohortId: self.cohortConfig.currentCohort, userId: self.currentUserId })
                .$promise.then(function (res) {
                  Application.messaging.addMessage({ type: 'success', duration: 5, text: "Successfully enrolled in Multi Session Workshop '" + self.workshop.name + "'" });
                  self.config.isRegistered = true;
                  self.sessionsConfig.allAvailableSeats -= 1;
                  self.config.setButtons();
                  self.config.loading = false;
                })
                .catch(function (err) {
                  console.error('Error registering for Multi Session Workshop: ', err);
                  self.config.loading = false;
                });
            },
            cancelRegistration: function () {
              self.config.loading = true;
              MultiSessionWorkshops.unregister({ subresource: self.workshop.id }, { userId: self.currentUserId })
                .$promise.then(function (res) {
                  $translate('multiSessionWorkshopViewer.successfullyRegisteredMessage', { name: self.workshop.name }).then(function (data) {
                    Application.messaging.addMessage({
                      type: 'success',
                      duration: 5,
                      text: data,
                    });
                  });
                  self.config.isRegistered = false;
                  if (!self.config.attendedSome) {
                    self.sessionsConfig.allAvailableSeats += 1;
                  }
                  self.config.attendedChoosingNewDates = false;
                  self.config.setButtons();
                  self.config.loading = false;
                })
                .catch(function (err) {
                  console.error('Error canceling registration from Multi Session Workshop: ', err);
                  self.config.loading = false;
                });
            },
            validateRegistration: function () {
              if ((self.cohortConfig.isCohort && !self.cohortConfig.validateCohortRegistration(self.cohortConfig.currentCohort)) || self.sessionsConfig.allAvailableSeats < 1) {
                Application.messaging.addMessage({ type: 'error', duration: 6, text: 'Unable to register for this Multi Session Workshop. One or more sessions have no available dates.' });
                return false;
              }
              if (self.workshop.registrationDisabled === true) {
                Application.messaging.addMessage({ type: 'error', duration: 6, text: 'Unable to register for this Multi Session Workshop. Registration is currently disabled.' });
                return false;
              }
              return true;
            },
            goDiscussion: function () {
              self.config.activeTab = 'discussion';
            },
            attendedSomeChangeFutureDates: function () {
              self.config.loading = true;
              const instanceIds = Object.values(self.sessionsConfig.selectedInstanceIdsBySessionId).concat(Object.values(self.sessionsConfig.attendedSessions));

              MultiSessionWorkshops.unregister({ subresource: self.workshop.id }, { userId: self.currentUserId })
                .$promise.then(function (res) {
                  self.config.setAllRegisteredInstances(instanceIds);

                  MultiSessionWorkshops.register({ subresource: self.workshop.id }, { instanceIds: instanceIds, userId: self.currentUserId }).$promise.then(function (res) {
                    Application.messaging.addMessage({ type: 'success', duration: 5, text: "Successfully changed future dates in Multi Session Workshop '" + self.workshop.name + "'" });
                    self.config.isRegistered = true;
                    self.config.attendedChoosingNewDates = false;
                    self.config.setButtons();
                    self.config.loading = false;
                  });
                })
                .catch(function (err) {
                  console.error('Error changing dates for future workshops', err);
                  self.config.loading = false;
                });
            },
            calculateAverageRating: function () {
              let totalRatings = 0;
              let ratingCounter = 0;
              const stringIds = self.sessionsConfig.allSessionIds.join(',');
              const query = {
                content_id: `$in,${self.sessionsConfig.allSessionIds.length},${stringIds}`,
              };

              Ratings.find(query).$promise.then(function (results) {
                if (results.length) {
                  results.forEach((result) => {
                    if (result.rating) {
                      ratingCounter++;
                      totalRatings += result.rating;
                    }
                  });
                }
                if (totalRatings && ratingCounter) {
                  self.config.averageRating = Math.ceil(totalRatings / ratingCounter);
                }
              });
            },
          };

          self.config = {
            contentType: 'multi_session_workshop',
            loading: false,
            canRegister: false,
            canLeave: false,
            isRegistered: false,
            attendedSome: false,
            attendedAll: false,
            attendedChoosingNewDates: false,
            attendedCanRegisterNewDates: false,
            activeTab: 'information',
            pastInstanceIds: [],
            dateRange: {
              earliest: '',
              latest: '',
            },
            registeredInstanceIdsBySessionId: {},
            relatedWorkshops: [],
            averageRating: 0,
            setAllRegisteredInstances: function (instanceIds) {
              for (var i = 0; i < instanceIds.length; i++) {
                var instanceId = instanceIds[i];
                for (var j = 0; j < self.workshop.sessions.length; j++) {
                  var session = self.workshop.sessions[j];
                  var instances = self.workshop.sessions[j].instances;
                  for (var k = 0; k < instances.length; k++) {
                    var instance = instances[k];
                    if (instance.id === instanceId) {
                      self.config.setOneRegisteredInstance(session.id, instance.id);
                    }
                  }
                }
              }
            },
            setOneRegisteredInstance: function (sessionId, instanceId) {
              self.config.registeredInstanceIdsBySessionId[sessionId] = instanceId;
            },
            setUserRegistrationStatus: function () {
              var userRegistrationCount = 0;
              var userAttendedCount = 0;
              for (var i = 0; i < self.workshop.sessions.length; i++) {
                var session = self.workshop.sessions[i];
                for (var j = 0; j < session.instances.length; j++) {
                  var instance = session.instances[j];
                  var registration = instance.userRegistrations.find(function (userRegistration) {
                    if (userRegistration.userId === self.currentUserId && userRegistration.status === 'attended') {
                      // count attended instance as registered for this situation
                      self.config.setOneRegisteredInstance(session.id, instance.id);
                      self.sessionsConfig.attendedSessions[session.id] = instance.id;
                      userAttendedCount++;
                      //map attended workshops for ratings
                      let newSessionObj = { ...self.workshop.sessions[i] };
                      newSessionObj.workshopInstance = session.instances[j];
                      newSessionObj.rating_configuration = {
                        allow_rating: newSessionObj.contentSettings.enableRatings,
                        allow_edits: newSessionObj.contentSettings.enableEdits,
                        allow_feedback: newSessionObj.contentSettings.enableFeedback,
                        total_value: 5,
                      };
                      self.sessionsConfig.fullAttendedSessions.push(newSessionObj);
                      self.triggerRating = true;
                    }
                    return userRegistration.userId === self.currentUserId && userRegistration.status === 'registered';
                  });
                  if (!!registration) {
                    self.config.setOneRegisteredInstance(session.id, instance.id);
                    self.sessionsConfig.selectedInstanceIdsBySessionId[session.id] = instance.id;
                    if (moment() > moment(instance.end)) {
                      // count past 'registered' dates as 'attended' until marked otherwise
                      self.sessionsConfig.attendedSessions[session.id] = instance.id;
                      userAttendedCount++;
                    } else {
                      userRegistrationCount++;
                    }
                  }
                }
                const totalSessionCount = self.sessionsConfig.allSessionIds.length;
                self.config.attendedSome = userAttendedCount > 0 && userAttendedCount < totalSessionCount;
                self.config.attendedAll = userAttendedCount === totalSessionCount;
                self.config.isRegistered = userRegistrationCount === totalSessionCount || userRegistrationCount + userAttendedCount === totalSessionCount;
              }
              self.config.setButtons();
            },
            setButtons: function () {
              self.config.canRegister = false;
              self.config.canLeave = false;

              var totalSelectedDates = 0;
              const totalAttendedDates = Object.keys(self.sessionsConfig.attendedSessions).length || 0;
              if (!self.cohortConfig.isCohort) {
                totalSelectedDates = Object.keys(self.sessionsConfig.selectedInstanceIdsBySessionId).length;
              } else if (self.cohortConfig.isCohort && self.cohortConfig.currentCohort) {
                totalSelectedDates = self.cohortConfig.instancesByCohortId[self.cohortConfig.currentCohort].length;
              }
              var totalSessions = self.sessionsConfig.allSessionIds.length;

              if (self.config.isRegistered) {
                self.config.canLeave = true;
                if (self.config.attendedSome) {
                  if (!self.sessionsConfig.checkSelectedDatesAreChronological()) {
                    self.config.attendedCanRegisterNewDates = false;
                    Application.messaging.addMessage({ type: 'error', duration: 6, text: 'Sessions must be attended in order. Please select different dates.' });
                  } else {
                    self.config.attendedCanRegisterNewDates = true;
                  }
                }
              } else if (((self.cohortConfig.isCohort && self.cohortConfig.validateCohortRegistration(self.cohortConfig.currentCohort)) || !self.cohortConfig.isCohort) && totalSelectedDates + totalAttendedDates === totalSessions) {
                if (self.sessionsConfig.checkSelectedDatesAreChronological()) {
                  self.config.canRegister = true;
                } else {
                  Application.messaging.addMessage({ type: 'error', duration: 6, text: 'Sessions must be attended in order. Please select different dates.' });
                }
              }
            },
            getDateRange: function () {
              var now = moment();
              var earliest = '';
              var latest = '';
              for (var i = 0; i < self.workshop.sessions.length; i++) {
                for (var j = 0; j < self.workshop.sessions[i].instances.length; j++) {
                  var instance = self.workshop.sessions[i].instances[j];
                  if ((!earliest || moment(instance.start).isBefore(earliest)) && moment(instance.start).isSameOrAfter(now)) {
                    earliest = instance.start;
                  }
                  if ((!latest || moment(instance.end).isAfter(latest)) && moment(instance.end).isSameOrAfter(now)) {
                    latest = instance.end;
                  }
                }
              }
              return { earliest: earliest, latest: latest };
            },
            dateFormat: function (location, type) {
              if (!self.config.dateRange.earliest) {
                return '';
              }
              if (location === 'top') {
                if (type === 'month') {
                  return moment(new Date(self.config.dateRange.earliest).valueOf()).tz(guessedTz).format('MMM');
                }
                if (type === 'day') {
                  return moment(new Date(self.config.dateRange.earliest).valueOf()).tz(guessedTz).format('D');
                }
                if (type === 'range') {
                  return (
                    moment(new Date(self.config.dateRange.earliest).valueOf()).tz(guessedTz).format('MMMM Do, YYYY') +
                    ' - ' +
                    moment(new Date(self.config.dateRange.latest).valueOf()).tz(guessedTz).format('MMMM Do, YYYY')
                  );
                }
              }
            },
            attachInstanceTimeOptions: function () {
              for (var i = 0; i < self.workshop.sessions.length; i++) {
                var session = self.workshop.sessions[i];
                self.sessionsConfig.allSessionIds.push(session.id);
                var instanceDates = [];
                const sortedDates = this.sortByDates(session.instances);
                for (var j = 0; j < sortedDates.length; j++) {
                  var instance = sortedDates[j];
                  var instanceTimeOption = self.config.getInstanceTimeOptions(instance, session.id);
                  if (instanceTimeOption) {
                    instanceDates.push(instanceTimeOption);
                  }
                }
                session.instanceOptions = instanceDates;
              }
            },
            sortByDates: function (instanceArray) {
              return instanceArray.sort(function (a, b) {
                return new Date(a.start) - new Date(b.start);
              });
            },
            getInstanceTimeOptions: function (instance, sessionId) {
              var now = moment();
              // verify this instance has seats left
              if (self.config.getInstanceAvailableSeats(instance) <= 0) {
                self.sessionsConfig.unavailableInstanceIds.push(instance.id);
                return;
              }
              var venue = instance.online ? instance.instanceUrlTitle : instance.venue;
              var startMoment = moment(new Date(instance.start).valueOf()).tz(guessedTz);
              if (startMoment < now) {
                self.config.pastInstanceIds.push(instance.id);
              }
              var option = startMoment.format('MMM D, YYYY') + ' @ ' + startMoment.format('LT') + ' | ' + venue;
              return {
                name: option,
                value: instance.id,
              };
            },
            getInstanceAvailableSeats: function (instance) {
              var total = instance.capacity;
              var registered = 0;
              for (var i = 0; i < instance.userRegistrations.length; i++) {
                if (instance.userRegistrations[i].status === 'registered') {
                  registered++;
                }
              }
              return total - registered;
            },
            cohortDataInit: function () {
              if (self.cohortConfig.isCohort) {
                self.cohortConfig.createCohortsList();
                self.cohortConfig.createCohortsMaps();
                if (self.config.isRegistered) {
                  const sessionIdForGettingCohort = self.workshop.sessions[0].id;
                  const registeredInstanceId = self.config.registeredInstanceIdsBySessionId[sessionIdForGettingCohort];
                  self.cohortConfig.registeredCohortName = self.workshop.cohorts.find((cohort) => cohort.instanceIds.includes(registeredInstanceId)).name;
                }
              }
            },
            goTo: function(workshop) {
              if (!workshop || !workshop._id) {
                return;
              }
              if (workshop.type === 'multi_session_workshop') {
                Application.navigation.goTo('view/multi-session-workshops/' + workshop._id);
              } else {
                Application.navigation.goTo('view/workshops/' + workshop._id);
              }
            },
            setRelated: function(workshop) {
              var promises = [];
              if (!workshop.relatedWorkshops || !workshop.relatedWorkshops.length) {
                return;
              }
              var workshopIds = workshop.relatedWorkshops.map(function(item) {
                if (typeof item === 'string') {
                  return item;
                }
                if (item._id) {
                  return item._id;
                }
              });
              if (!workshopIds || !workshopIds.length) {
                return;
              }
    
              var promises = [
                WorkshopInstances.find({
                  workshop: '$in,' + workshopIds.length + ',' + workshopIds.join(','),
                  fields: 'workshop,start_date,location,online'
                }).$promise
              ];
    
              if (typeof workshop.relatedWorkshops[0] === 'string') {
                promises.push(
                  Workshops.find({
                    _id: '$in,' + workshopIds.length + ',' + workshopIds.join(','),
                    fields: '_id,type,title,image,banner_image'
                  }).$promise
                );
              }
    
              $q.all(promises).then(function(data) {
                var instances = data[0];
                var workshops = data[1] || workshop.relatedWorkshops || [];
                var options = {};
                workshops.forEach(function(workshop) {
                  options[workshop._id] = {workshop: workshop, instance: null};
                });
                instances.forEach(function(instance) {
                  if (options[instance.workshop].instance) {
                    options[instance.workshop].instance = 'multiple';
                    return;
                  }
                  options[instance.workshop].instance = instance;
                });
                for (var key in options) {
                  self.config.relatedWorkshops.push(options[key]);
                }
              });
            },
            image: function(workshop) {
              if (workshop.image || workshop.banner_image) {
                var imageUrl = workshop.image || workshop.banner_image || '';
                return Application.imageCdn.baseUrl + Application.imageCdn.sharedProps + '/' + imageUrl;
              }
              return '';
            },
            makeDate: function(instance) {
              if (!instance || !instance.start_date) {
                return '';
              }
              return moment(new Date(instance.start_date).valueOf()).tz(guessedTz).format('ddd, MMM h:mmA');
            },
          };

          self.surveysConfig = {
            showSurveyPopup: false,
            selectedSurveyId: null,
            selectedSurveySessionId: null, 
            showSessionsSurvey: function(sessionId, surveyId) {
              // don't count another view if survey is already selected
              if (self.surveysConfig.selectedSurveyId !== surveyId) {
                Analyze.record({resource: 'views'}, {content: surveyId, content_type: 'survey'});
              }
              self.surveysConfig.selectedSurveySessionId = sessionId;
              self.surveysConfig.selectedSurveyId = surveyId;
              self.surveysConfig.showSurveyPopup = true;
            },
            surveyMap: {},
            mapSessionToSurvey: async function(sessions) {
              for (let i = 0; i < sessions.length; i++) {
                if (sessions[i].details.surveys?.length && self.sessionsConfig.attendedSessions[sessions[i].id]) {
                  const hideSurvey = await SurveyHelper.hideSurvey(self.inJourney, sessions[i].details.surveys[0].survey_id, sessions[i].id);
                  $scope.$apply();
                  this.surveyMap[sessions[i].id] = {
                    survey: sessions[i].details.surveys[0].survey_id,
                    hideSurvey
                  }
                }
              }
          
            }
          }

          self.sessionsConfig = {
            unavailableInstanceIds: [],
            allSessionIds: [],
            attendedSessions: {},
            selectedInstanceIdsBySessionId: {},
            allAvailableSeats: 0,
            fullAttendedSessions: [],
            getAllAvailableSeats: function () {
              // session with lowest amount of seats between all instances marks number of available seats in the MSW
              var lowestSessionSeats;
              for (var i = 0; i < self.workshop.sessions.length; i++) {
                var sessionSeatsTotal = 0;
                var sessionSeatsTaken = 0;
                for (var j = 0; j < self.workshop.sessions[i].instances.length; j++) {
                  var instance = self.workshop.sessions[i].instances[j];
                  sessionSeatsTotal += instance.capacity;
                  for (var k = 0; k < instance.userRegistrations.length; k++) {
                    if (instance.userRegistrations[k].status === 'registered' || instance.userRegistrations[k].status === 'attended' || instance.userRegistrations[k].status === 'absent') {
                      sessionSeatsTaken++;
                    }
                  }
                }
                var sessionSeatsAvailable = sessionSeatsTotal - sessionSeatsTaken;
                if ((!lowestSessionSeats && lowestSessionSeats !== 0) || sessionSeatsAvailable < lowestSessionSeats) {
                  lowestSessionSeats = sessionSeatsAvailable;
                }
              }
              return lowestSessionSeats;
            },
            getRegisteredInstance: function (session) {
              return session.instanceOptions.find((s) => s.value === self.config.registeredInstanceIdsBySessionId[session.id]);
            },
            checkAttendedFutureSessionChange: function () {
              self.config.attendedChoosingNewDates = false;
              for (const sessionId in self.sessionsConfig.selectedInstanceIdsBySessionId) {
                if (self.config.registeredInstanceIdsBySessionId[sessionId] !== self.sessionsConfig.selectedInstanceIdsBySessionId[sessionId]) {
                  self.config.attendedChoosingNewDates = true;
                }
              }
            },
            checkSelectedDatesAreChronological: function () {
              // cohorts should defer to specifically chosen dates specified in the sessions
              if (self.cohortConfig.currentCohort) {
                return true;
              }
              // assumes self.workshop.sessions is the intended order of sessions
              let orderedInstanceTimes = self.workshop.sessions.map((session) => {
                if (self.sessionsConfig.attendedSessions[session.id]) {
                  return moment(session.instances.find((instance) => instance.id === self.sessionsConfig.attendedSessions[session.id]).start);
                }
                return moment(session.instances.find((instance) => instance.id === self.sessionsConfig.selectedInstanceIdsBySessionId[session.id]).start);
              });
              for (let i = 0; i < orderedInstanceTimes.length; i++) {
                const currentTime = orderedInstanceTimes[i];
                const nextTime = orderedInstanceTimes[i + 1];
                if (!nextTime) {
                  break;
                }
                if (!currentTime || currentTime >= nextTime) {
                  return false;
                }
              }
              self.config.dateRange.earliest = orderedInstanceTimes[0];
              self.config.dateRange.latest = orderedInstanceTimes[orderedInstanceTimes.length - 1];
              return true;
            },
          };

          self.cohortConfig = {
            isCohort: false,
            cohortsList: [],
            currentCohort: '',
            registeredCohortName: '',
            cohortBySessionId: {},
            instancesByCohortId: {},
            pastCohortIds: [],
            createCohortsList: function () {
              self.cohortConfig.cohortsList = self.workshop.cohorts.map(function (cohort) {
                return { name: cohort.name, value: cohort.id };
              });
            },
            validateCohortRegistration: (cohortId) => {
              if (self.sessionsConfig.unavailableInstanceIds.length < 1 || !self.cohortConfig.isCohort) {
                return true;
              }
              if (!self.cohortConfig.currentCohort) {
                return false;
              }
              const cohortInstances = self.cohortConfig.instancesByCohortId[cohortId];
              for (const cohortInstance of cohortInstances) {
                if (self.sessionsConfig.unavailableInstanceIds.includes(cohortInstance)) {
                  return false;
                }
              }
              return true;
            },
            createCohortsMaps: function () {
              /*
          output examples:

          cohortBySessionId:
            {
            "sessionId62700135b92ca": {
              "cohortId94c0c71b0cd8d7": {
                "name": "May 20, 2022 @ 2:00 PM | venue 1",
                "value": "625dde9010f62700135b92d7"
              },
              "cohortId94c0c71b0cd8d8": {
                "name": "May 21, 2022 @ 2:00 PM | venue 2",
                "value": "625ddea310f62700135b92ec"
              }
            },
            "sessionId62700135b935b": {
              "cohortId94c0c71b0cd8d7": {
                "name": "May 25, 2022 @ 2:00 PM | venue 3",
                "value": "instanceIdf62700135b9368"
              },
              "cohortId94c0c71b0cd8d8": {
                "name": "May 26, 2022 @ 2:00 PM | venue 4",
                "value": "instanceIdf62700135b937d"
              }
            }
          }
          instancesByCohortId:
            {
              "cohortId94c0c71b0cd8d7": [
                "instanceId10f62700135b92d7",
                "instanceId10f62700135b9368"
              ],
              "cohortId594c0c71b0cd8d8": [
                "instanceId10f62700135b92ec",
                "instanceId10f62700135b937d"
              ]
            }
           */
              var now = moment();
              self.workshop.sessions.forEach(function (session) {
                session.instances.forEach(function (instance) {
                  self.workshop.cohorts.forEach(function (cohort) {
                    cohort.instanceIds.forEach(function (cohortInstanceId) {
                      if (cohortInstanceId === instance.id) {
                        if (!self.cohortConfig.cohortBySessionId[session.id]) {
                          self.cohortConfig.cohortBySessionId[session.id] = {};
                        }
                        self.cohortConfig.cohortBySessionId[session.id][cohort.id] = session.instanceOptions.find(function (option) {
                          return option.value === instance.id;
                        });
                        if (!self.cohortConfig.instancesByCohortId[cohort.id]) {
                          self.cohortConfig.instancesByCohortId[cohort.id] = [];
                        }
                        self.cohortConfig.instancesByCohortId[cohort.id].push(instance.id);
                        if (moment(instance.start) < now) {
                          self.cohortConfig.pastCohortIds.push(cohort.id);
                        }
                      }
                    });
                  });
                });
              });
            },
          };

          self.workshop = {
            id: '',
            companyId: self.company,
            creatorId: '',
            firstName: '',
            lastName: '',
            enableRatings: false,
            enableComments: false,
            enableFeedback: false,
            displayRating: false,
            name: '',
            description: '',
            bannerImage: '',
            coverImage: '',
            registrationDisabled: false,
            sessions: [],
            type: 'freeform',
            cohorts: [],
          };

          self.initSelectedInstanceWatcher = function () {
            return $scope.$watch(
              'viewer.sessionsConfig.selectedInstanceIdsBySessionId',
              function (newVal, oldVal) {
                if (!newVal || newVal === oldVal) {
                  return;
                }
                if (self.config.attendedSome) {
                  self.sessionsConfig.checkAttendedFutureSessionChange();
                }

                self.sessionHostDetails = {};

                Object.entries(self.sessionsConfig.selectedInstanceIdsBySessionId).forEach(([sessionId, instanceId]) => {
                  self.workshop.sessions
                    .filter((session) => session.id === sessionId)
                    .forEach((session) => {
                      session.instances.filter((instance) => {
                        if (instance.id === instanceId) {
                          self.sessionHostDetails[instanceId] = {
                            facilitatorName: instance.facilitatorName,
                            facilitatorImage: instance.facilitatorImage,
                          };
                        }
                      });
                    });
                });

                self.config.setButtons();
              },
              true
            );
          };

          $scope.$watch('viewer.cohortConfig.currentCohort', function (newVal, oldVal) {
            if (!newVal || newVal === oldVal) {
              return;
            }

            self.cohortSessionHostDetails = {};
            let chosenInstanceDates = [];
            self.workshop.cohorts
              .filter((cohort) => cohort.id === self.cohortConfig.currentCohort)
              .forEach((cohort) => {
                cohort.instanceIds.forEach((instanceId) => {
                  self.workshop.sessions.forEach((session) => {
                    session.instances.filter((instance) => {
                      if (instance.id === instanceId) {
                        self.cohortSessionHostDetails[session.id] = {
                          facilitatorName: instance.facilitatorName,
                          facilitatorImage: instance.facilitatorImage,
                        };
                        chosenInstanceDates.push(instance.start);
                      }
                    });
                  });
                });
              });
            chosenInstanceDates.sort((a, b) => {
              return moment(a).isAfter(b) ? 1 : -1;
            });
            self.config.dateRange.earliest = chosenInstanceDates[0];
            self.config.dateRange.latest = chosenInstanceDates[chosenInstanceDates.length - 1];
            self.config.setButtons();
          });

          self.initialize = function () {
            self.loading = true;
            if ($scope.preview) {
              self.inEditing = true;
              self.workshop = $scope.previewData;
              self.cohortConfig.isCohort = self.workshop.type === 'cohort';
              self.config.attachInstanceTimeOptions();
              self.config.cohortDataInit();
              self.config.dateRange = self.config.getDateRange();
              self.sessionsConfig.allAvailableSeats = self.sessionsConfig.getAllAvailableSeats();
              self.loading = false;
              return;
            }
            if (!self.contentId) {
              Application.messaging.addMessage({ type: 'error', duration: 3, text: 'Could not find MultiSession Workshop' });
              Application.navigation.goTo('/explore');
              return;
            }

            MultiSessionWorkshops.findOne({ subresource: self.contentId })
              .$promise.then(async function (msw) {
          
                const workshop = {
                  id: msw.id,
                  companyId: msw.companyId,
                  creatorId: msw.creatorId,
                  firstName: msw.firstName,
                  lastName: msw.lastName,
                  enableRatings: msw.enableRatings,
                  enableComments: msw.enableComments,
                  enableFeedback: msw.enableFeedback,
                  displayRating: msw.displayRating,
                  name: msw.name,
                  description: msw.description,
                  bannerImage: msw.bannerImage,
                  coverImage: msw.coverImage,
                  registrationDisabled: msw.registrationDisabled,
                  sessions: msw.sessions,
                  type: msw.type,
                  cohorts: msw.cohorts,
                  relatedWorkshops: msw.relatedWorkshops,
                  segmentation: msw.segmentation,
                  private: msw.isPrivate
                };

                const allowed = await ContentAuth.allowView(workshop, true);

                if(!allowed) {
                  Application.messaging.addMessage({type: 'error', text: 'You don’t have permission to access this content, please contact your administrator if you believe this is a mistake.', duration: 5});
                  Application.navigation.back();
                  return;
                }

                self.workshop = workshop;

                self.cohortConfig.isCohort = msw.type === 'cohort';
                self.config.attachInstanceTimeOptions();
                self.config.setUserRegistrationStatus();
                self.config.cohortDataInit();
                self.config.dateRange = self.config.getDateRange();
                self.sessionsConfig.allAvailableSeats = self.sessionsConfig.getAllAvailableSeats();
                self.surveysConfig.mapSessionToSurvey(workshop.sessions);
                self.actions.calculateAverageRating();
                self.initSelectedInstanceWatcher();
                Analyze.record({ resource: 'views' }, { content: self.workshop.id, content_type: 'workshop' });
                self.config.setRelated(self.workshop);
                self.loading = false;
              })
              .catch(function (err) {
                console.error('Error finding MultiSession Workshop: ', err);
                self.loading = false;
              });
          };
          self.initialize();
        },
      ],
      controllerAs: 'viewer',
    };
  },
]);
